import React from 'react'
import { TaskListHeader } from './TaskListHeader'
import { Table } from '@ztechapps/webui.data-tools'
import { TaskListRow } from './TaskListRow'
import { useTaskListContext } from './Context'
import { DataAction } from './DataAction'
import { Stack } from 'react-bootstrap'

export const List = () => {
  return (
    <Stack gap={2}>
      <DataAction />

      <TaskTable />
    </Stack>
  )
}

export const TaskTable = () => {
  const { components, loading, onDragSort, taskListWithSelection, scrollable, ...context } = useTaskListContext()

  const scrollHeight =
    typeof scrollable === 'object' ? (scrollable?.height ?? 'calc(100vh - 280px)') : 'calc(100vh - 280px)'

  return (
    <Table
      tableClassName="table table-striped"
      loading={loading}
      responsive={''}
      head={<TaskListHeader />}
      dataArray={taskListWithSelection?.list}
      row={TaskListRow}
      foot={<components.foot {...context} />}
      emptyContent={<components.emptyContent {...context} />}
      onDragSort={onDragSort}
      scrollable={!!scrollable}
      height={scrollHeight}
    />
  )
}
